/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_What_P2Inputs */

const en_fc_home_what_p2 = /** @type {(inputs: Fc_Home_What_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have edited in Adobe Premiere Pro, the FilmCraft video editor will feel familiar within minutes. Bins sit in the Project panel, clips load into a Source monitor, your sequence plays in the Program monitor, and the timeline supports three-point editing with ripple, roll, slip and slide trims. The keyboard follows the same conventions: comma inserts, period overwrites, and J, K and L shuttle through footage.`)
};

/**
* | output |
* | --- |
* | "If you have edited in Adobe Premiere Pro, the FilmCraft video editor will feel familiar within minutes. Bins sit in the Project panel, clips load into a Sour..." |
*
* @param {Fc_Home_What_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_what_p2 = /** @type {((inputs?: Fc_Home_What_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_What_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_what_p2(inputs)
});
export { fc_home_what_p2 as "fc.home.what.p2" }